<template>
  <van-dialog
    v-model="show"
    title="快捷录票"
    show-cancel-button
    @close="onDialogClose"
    @confirm="onSubmit"
    :beforeClose="onBeforeClose"
    @open="doQuery"
  >
    <van-form style="min-height: 2.5rem" label-width="1.8rem">
      <van-field name="peopleNum" label="人数">
        <template #input>
          <van-stepper v-model="peopleNum" :max="canSaleMaxTicket" integer />
        </template>
      </van-field>
      <van-field
        v-model="totalAmount"
        type="number"
        name="totalAmount"
        label="金额"
        placeholder="请输入上车金额"
        :error-message="amountErrorMsg"
      />
      <van-field name="payType" label="支付方式">
        <template #input>
          <van-radio-group v-model="payType" direction="horizontal">
            <van-radio name="CashPay">现金支付</van-radio>
            <van-radio name="AllinpayScanPayBSC">微信扫码</van-radio>
          </van-radio-group>
        </template>
      </van-field>
    </van-form>
  </van-dialog>
</template>

<script>
export default {
  model: {
    prop: "isShow",
    event: "change",
  },
  props: {
    isShow: Boolean,
    /**
     * 扩展表单数据
     */
    extendFormData: Object,
  },
  data() {
    return {
      canSaleMaxTicket: 5,
      show: false,
      totalAmount: null, //总支付金额
      peopleNum: null, //人数
      //shares: [], // 每个人的分摊金额数组
      payType: "CashPay",
      arrivalNodeList: [], // 下车点数组列表
      // 错误信息
      amountErrorMsg: "",
      createOrderJson: null,
      OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象
    };
  },
  watch: {
    isShow(newVal) {
      this.show = newVal;
    },
  },
  methods: {
    // 获取下车点
    async getArrivalNode() {
      let params = {
        LineClassDayGID: this.extendFormData.LineClassDayGID,
      };
      await this.$http
        .post(this.$api.getArrivalNode, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.arrivalNodeList = res.data
              .filter((item) => item.IsCanSale)
              .sort((a, b) => a.RunTime - b.RunTime);
          }
        });
    },
    // 取消默认关闭弹框事件
    onBeforeClose(action, done) {
      if (action == "confirm") {
        return done(false);
      }
      return done(true);
    },
    onDialogClose() {
      this.$emit("change", this.show);
    },
    async onSubmit() {
      await this.getArrivalNode();
      // 填写了才判断  ^\d+(\.\d{1,2})?$ 最多两位小数
      var regex = /^\d+(\.\d{1,2})?$/;
      if (!regex.test(this.totalAmount)) {
        this.amountErrorMsg = "请输入最多包含两位小数的数字";
      } else {
        this.amountErrorMsg = "";
        //创建订单  注意PassengerJsonText 中每个元素就是一个座位
        var PassengerJsonText = [];
        // 将输入的对象数量转换为数字
        const count = parseInt(this.peopleNum);
        // 检查输入的数量是否有效
        if (!isNaN(count) && count > 0) {
          // 先计算平均每个人应支付的金额，并保留两位小数
          let averageShare = parseFloat(
            (this.totalAmount / this.peopleNum).toFixed(2)
          );
          // 计算所有人按平均金额支付后的总金额
          let totalCalculated = averageShare * this.peopleNum;
          // 计算余数，即总金额与按平均计算的总金额的差值
          let remainder = parseFloat(
            (this.totalAmount - totalCalculated).toFixed(2)
          );

          // // 初始化每个人的分摊金额数组
          // this.shares = Array(this.peopleNum).fill(averageShare);

          // // 处理余数，将余数依次分摊到部分人头上
          // let i = 0;
          // while (remainder > 0) {
          //   // 每次分摊 0.01 元
          //   this.shares[i] = parseFloat((this.shares[i] + 0.01).toFixed(2));
          //   remainder = parseFloat((remainder - 0.01).toFixed(2));
          //   i = (i + 1) % this.peopleNum;
          // }

          for (let i = 0; i < count; i++) {
            let amount = averageShare;
            if (i === 0) {
              amount += remainder;
            }

            // 创建新的对象
            var newObject = {
              TicketType: 1,
              CustName: "",
              CustTel: null,
              CustCertType: "其它",
              CustCertNo: "",
              IsChild: false,
              ChildName: null,
              ChildCertType: null,
              ChildCertNo: null,
              SeatNo: 0,
              TicketPrice: amount,
            };
            // 将新对象添加到数组中
            PassengerJsonText.push(newObject);
          }
        }

        let params = {
          AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
          LineClassDayGID: this.extendFormData.LineClassDayGID,
          StartNodeGID: this.extendFormData.StartNodeGID,
          //下车点在订单创建时默认最后一个可售下车点
          ArrivalNodeGID:
            this.arrivalNodeList[this.arrivalNodeList.length - 1].NodeGID,
          PassengerJsonText: JSON.stringify(PassengerJsonText),
          ContactName: "",
          ContactTel: null,
          OrderTypeID: 1,
          WeiXinOpenID: null,
          WeiXinAppID: null,
          OperGID: this.OperObj.GID, //操作员GID
          OperCode: this.OperObj.UserCode, //操作员代码
          OperName: this.OperObj.UserName, //操作员名称
        };
        this.createOrderJson = params;
        //如果是扫码，先扫码再创建订单，防止扫码失败重复创建订单
        if (this.payType == "CashPay") {
          this.toCreatOrder();
        } else {
          this.onSacnQRCode();
        }
      }
    },
    toCreatOrder(payCode) {
      this.$http
        .post(
          this.$api.createTicketOrder,
          this.$qs.stringify(this.createOrderJson)
        )
        .then((res) => {
          if (res.success) {
            this.$toast("订单创建成功");
            this.ticketOrderPayDo(this.payType, res.data[0].OrderNo, payCode);
          } else {
            this.$dialog.alert({
              title: "提示",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    //唤起扫码
    onSacnQRCode() {
      //调起摄像头扫码
      var that = this;
      if (window.framework && window.framework.jsCameraScan) {
        this.$emit("child-value", this.createOrderJson);
        // //手机扫码回调
        // var phoneScanfun = function (scanResult) {
        //   this.checkMode = "手机相机扫码";
        //   //扫码失败
        //   if (
        //     scanResult == "" ||
        //     scanResult == null ||
        //     scanResult.length == 0
        //   ) {
        //     this.$toast.fail("扫码失败！");
        //     return;
        //   }
        //   that.toCreatOrder(scanResult);
        // };
        // // 定位回调
        // window.callCameraScan = phoneScanfun.bind(this);

        window.framework.jsCameraScan();
      } else {
        if (this.$utils.getIsWxClient()) {
          wx.ready(function () {
            wx.scanQRCode({
              needResult: 1,
              scanType: ["qrCode"],
              success: function (t) {
                that.toCreatOrder(t.resultStr);
              },
              fail: function (e) {
                alert(e);
              },
            });
          });
        } else {
          this.$toast("调起扫码失败，请检查设备！");
          return;
        }
      }
    },

    // 支付订单
    ticketOrderPayDo(PayTypeCode, OrderNo, payCode) {
      let params = {
        PayTypeCode: PayTypeCode,
        OrderNo: OrderNo,
        OperGID: this.OperObj.GID, //操作员GID
        OperCode: this.OperObj.UserCode, //操作员代码
        OperName: this.OperObj.UserName, //操作员名称
      };
      this.$http
        .post(
          this.$api.onTicketOrderPayDo,
          this.$qs.stringify({
            model: params,
            authcode: payCode,
          })
        )
        .then((res) => {
          if (res.success) {
            this.$toast("出票成功");

            //直接检票
            if (
              res.data.length > 0 &&
              this.$utils.getSysParams("IsAfterSaleCheck") !== "0"
            ) {
              res.data.forEach((t) => {
                this.onCheck(t, false);

                this.$emit("child-value", "刷新页面");
              });

              //隐藏
              this.show = false;
            }
          } else {
            this.$toast("出票失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //检票
    onCheck(ticket) {
      let params = {
        AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
        BarCode: ticket.BarCode, //车票条码
        LineClassDayGID: this.extendFormData.LineClassDayGID, //日班次GID
        StartNodeGID: this.extendFormData.StartNodeGID, //发车点GID
        CheckModeFlag: 1, //是否身份证检票
        CheckRemark: ticket.Remark,
        OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
        OperCode: JSON.parse(window.localStorage.getItem("adminInfo")).UserCode, //操作员代码
        OperName: JSON.parse(window.localStorage.getItem("adminInfo")).UserName, //操作员名称
        //: JSON.stringify(ticket.CheckRemark),
      };
      this.$http
        .post(this.$api.onCheckTicket, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.$toast("检票成功");
          } else {
            this.$toast("检票失败");
          }
        })
        .catch((err) => {});
    },

    // 信息查询
    doQuery() {},
  },
  created() {
    //单个订单最多可售票数
    this.canSaleMaxTicket = this.$utils.getSysParams("CanSaleMaxTicketInOrder");
  },
  // mounted() {
  //   var that = this;
  //   //手机扫码回调
  //   var phoneScanfun = function (scanResult) {
  //     this.checkMode = "手机相机扫码";
  //     //扫码失败
  //     if (scanResult == "" || scanResult == null || scanResult.length == 0) {
  //       this.$toast.fail("扫码失败！");
  //       return;
  //     }
  //     that.toCreatOrder(scanResult);
  //   };
  //   // 定位回调
  //   window.callCameraScan = phoneScanfun.bind(this);
  // },
};
</script>

<style lang="less" scoped></style>